import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77b08b9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_card_cell = _resolveComponent("oxd-card-cell")!
  const _component_oxd_card_tr = _resolveComponent("oxd-card-tr")!
  const _component_oxd_card_tbody = _resolveComponent("oxd-card-tbody")!

  return (_openBlock(), _createBlock(_component_oxd_card_tbody, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(_ctx.classes),
          key: item,
          onClick: ($event: any) => (_ctx.onClick(item)($event))
        }, [
          _createVNode(_component_oxd_card_tr, {
            clickable: _ctx.tableProps.clickable
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oxd_card_cell, {
                class: "oxd-padding-cell",
                headers: _ctx.defaultSlot,
                items: item,
                index: index
              }, null, 8, ["headers", "items", "index"])
            ]),
            _: 2
          }, 1032, ["clickable"])
        ], 10, _hoisted_1))
      }), 128))
    ]),
    _: 1
  }))
}